import { render, staticRenderFns } from "./WorkpostsmenuPage.vue?vue&type=template&id=25c210f3"
import script from "./WorkpostsmenuPage.vue?vue&type=script&lang=js"
export * from "./WorkpostsmenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports